export default __webpack_public_path__ + "static/media/GAN.2614f401.svg";